import React, { useEffect, useState } from "react";
import { InputGroup, Table } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import TableProperties from "./TableProperties";
import Moment from "react-moment";
import { studySiteDataEntryServices } from "../../../APIServices/studySiteDataEntryServices";
import { studyOtherSettingsServices } from "../../../APIServices/studyOtherSettingsServices";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import UseToggle from "../../../Hooks/UseToggle";
import { studySiteManagementServices } from "../../../APIServices/CTMS/SiteManagement/studySiteManagementServices";
import { studySubjectManagementServices } from "../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import { studyEventManagementServices } from "../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import ManagementFilterCanvas from "../ManagementFilterCanvas";
import { studyLevelFormManagementServices } from "../../../APIServices/studyLevelFormManagementServices";
import Pagination from "../../Pagination";
import FieldErrorNotification from "./FieldErrorNotification";
import { isHTMLIdentifier } from "../../../utils/universalFunction";
import SplitPane from "react-split-pane";
import { askReportFormat, saveReport } from "../../../utils/reportExport";

const emptyFilters = {
  siteId: "",
  subjectId: "",
  eventId: "",
  timePointId: "",
  formId: "",
  repeatEvent: "",
  repeatForm: "",
};

const ManageNotificationDataList = ({
  onMouseDown,
  tableRef,
  handleAddNewTab,
}) => {
  const [notificationList, setNotificationList] = useState([]);
  const [notificationListCount, setNotificationListCount] = useState(0);
  const [notificationData, setNotificationData] = useState("");
  const [dataEntryQueryNotificationDiscussionLoader, setDataEntryQueryNotificationDiscussionLoader] = useState(false);
  const [queryNotificationStatusButtonLoader, setQueryNotificationStatusButtonLoader] = useState(false);
  const [dataEntryQueryNotificationDiscussion, setDataEntryQueryNotificationDiscussion] = useState([]);
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2 } = UseToggle();
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [tableColumns, setTableColumns] = useState({});
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [siteList, setSiteList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [siteId, setSiteId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [eventId, setEventId] = useState("");
  const [timePointId, setTimePointId] = useState("");
  const [status, setStatus] = useState("ALL");
  const [formList, setFormList] = useState([]);
  const [formId, setFormId] = useState("");
  const [repeatEvent, setRepeatEvent] = useState("");
  const [repeatForm, setRepeatForm] = useState("");
  // The filter canvas edits the fields above (draft); the table only uses the applied values.
  const [draftStatus, setDraftStatus] = useState("ALL");
  const [appliedFilters, setAppliedFilters] = useState(emptyFilters);
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const formColumn = [
    { columnLabel: "SiteId", columnName: "SITEID", columnType: "text" },
    { columnLabel: "SubjectId", columnName: "SUBJECTID", columnType: "text" },
    { columnLabel: "EventId", columnName: "EVENTID", columnType: "text" },
    { columnLabel: "TimepointId", columnName: "TIMEPOINTID", columnType: "text" },
    { columnLabel: "Repeat Event", columnName: "REPEATEVENT", columnType: "text" },
    { columnLabel: "Form Name", columnName: "FORMNAME", columnType: "text" },
    { columnLabel: "Form Version", columnName: "FORMVERSION", columnType: "text" },
    { columnLabel: "Repeat Form", columnName: "REPEATFORM", columnType: "text" },
    { columnLabel: "Field Name", columnName: "FIELDNAME", columnType: "text" },
    { columnLabel: "Sub Field Name", columnName: "SUBFIELDNAME", columnType: "text" },
    { columnLabel: "First Generated Date | Time", columnName: "FIRSTGENERATEDDT", columnType: "text" },
    { columnLabel: "Last Generated Date | Time", columnName: "LASTGENERATEDDT", columnType: "text" },
    { columnLabel: "Notification Age", columnName: "NOTIFICATIONAGE", columnType: "text" },
    { columnLabel: "Status", columnName: "NOTIFICATIONSTATUS", columnType: "text" },
  ];

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPage, setTotalPage] = useState(0);
  const startIndex = (pageNumber - 1) * itemsPerPage;

  const getStudyFormFieldNotificationHistory = async () => {
    setLoading(true);
    let userData = { ...appliedFilters };
    userData.studyId = studyId;
    userData.mode = StudyMode;
    userData.status = status;
    userData.page = pageNumber;
    userData.length = itemsPerPage;
    let data =
      await studySiteDataEntryServices.getStudyFormFieldNotificationHistory(
        userData
      );
    setLoading(false);
    if (data === "AbortError") {
      setLoading(true);
    } else {
      setNotificationList(data?.data || []);
      setTotalPage(data?.totalPages || 0);
      setNotificationListCount(data?.count || 0);
      setLoading(false)
    }
  };

  const downloadNotificationReport = async () => {
    const format = await askReportFormat();
    if (!format) return;
    setExportLoading(true);
    try {
      const response = await studySiteDataEntryServices.getStudyFormFieldNotificationHistory(
        {
          ...appliedFilters,
          studyId,
          mode: StudyMode,
          status: "ALL",
        },
        false
      );
      const reportData = Array.isArray(response?.data) ? response.data : [];
      if (!reportData.length) {
        await Swal.fire({
          icon: "info",
          title: "No notification data",
          text: response?.customMessage || "No notification data is available for this report.",
        });
        return;
      }

      const toPlainText = (value) => {
        const text = String(value ?? "");
        return isHTMLIdentifier(text)
          ? new DOMParser().parseFromString(text, "text/html").body.textContent || ""
          : text;
      };
      const formatDateTime = (value) => {
        if (!value) return "";
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return String(value);
        const datePart = date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
        const timePart = date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false });
        return `${datePart} | ${timePart}`;
      };
      const formatField = (label, name) => {
        const labelText = toPlainText(label);
        return label === name ? labelText : `${labelText} | ${name ?? ""}`;
      };
      const columns = [
        { key: "SITEID", label: "SiteId", value: (notification) => notification?.siteName },
        { key: "SUBJECTID", label: "SubjectId", value: (notification) => notification?.subjectName },
        { key: "EVENTID", label: "EventId", value: (notification) => notification?.dataEntryType === "specialForm" ? "Special Form" : notification?.eventName },
        { key: "TIMEPOINTID", label: "TimepointId", value: (notification) => notification?.timePointId || "_" },
        { key: "REPEATEVENT", label: "Repeat Event", value: (notification) => notification?.repeatEvent },
        { key: "FORMNAME", label: "Form Name", value: (notification) => notification?.formName },
        { key: "FORMVERSION", label: "Form Version", value: (notification) => `v${notification?.formVersion}` },
        { key: "REPEATFORM", label: "Repeat Form", value: (notification) => notification?.repeatForm },
        { key: "FIELDNAME", label: "Field Name | Label", value: (notification) => formatField(notification?.mainFieldLabel, notification?.mainFieldName) },
        { key: "SUBFIELDNAME", label: "Sub Field Name | Label", value: (notification) => formatField(notification?.fieldLabel, notification?.fieldName) },
        { key: "FIRSTGENERATEDDT", label: "First Generated Date | Time", value: (notification) => formatDateTime(notification?.createdAt) },
        { key: "LASTGENERATEDDT", label: "Last Generated Date | Time", value: (notification) => formatDateTime(notification?.dueAge) },
        { key: "NOTIFICATIONAGE", label: "Notification Age", value: (notification) => notification?.notificationAge },
        { key: "NOTIFICATIONSTATUS", label: "Status", value: (notification) => notification?.status },
      ].filter((column) => !tableColumns[column.key]);
      const csvRows = [
        columns.map((column) => column.label),
        ...reportData.map((notification) => columns.map((column) => column.value(notification) ?? "")),
      ];
      saveReport(csvRows, format, "Notification_Report");
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Report download failed",
        text: error?.message || "Unable to export notification report.",
      });
    } finally {
      setExportLoading(false);
    }
  };

  const getTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getTablePropertiesData(
      "studyLevelDataNotifications",
      studyId
    );
    setTableColumns(data?.data || {});
  };

  const getStudySiteBasedonAccess = async () => {
    let data = await studySiteManagementServices.getStudySiteBasedonAccess(studyId, LoginCat, StudyMode)
    setSiteList(data?.data || [])
  }

  const getStudySubjectRowData = async (isCurrent = () => true) => {
    let data = await studySubjectManagementServices.getStudySubjectRowData("active", studyId, siteId, StudyMode)
    if (isCurrent()) setSubjectList(data?.data || [])
  }

  const getStudyEventRowData = async () => {
    let data = await studyEventManagementServices.getStudyEventRowData("active", studyId)
    setEventList(data?.data || [])
  }

  const getStudyLevelForm = async () => {
    let data = await studyLevelFormManagementServices.getStudyLevelForm(studyId, "edc", "active", StudyMode)
    setFormList(data?.data || [])
  }

  const getStudySubjectFormFieldQueryNotificationDiscussionDataEntry = async (siteId, subjectId, formId, queryId) => {
    setDataEntryQueryNotificationDiscussionLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = siteId
    userData.subjectId = subjectId
    userData.formId = formId
    userData.queryId = queryId
    let data = await studySiteDataEntryServices.getStudySubjectFormFieldQueryNotificationDiscussionDataEntry(userData)
    if (data === "AbortError") {
      setDataEntryQueryNotificationDiscussionLoader(true);
    } else {
      setDataEntryQueryNotificationDiscussion(data?.data || [])
      setDataEntryQueryNotificationDiscussionLoader(false)
    }
  }

  const generateQueryNotificationStatusStudySubjectFormField = async (siteId, subjectId, schemaId, eventId, timePointUniqueId, formId, queryId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Close this Notification Error!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Close it!`,
    }).then(async (result) => {
      let userData = {}
      setQueryNotificationStatusButtonLoader(true)
      userData.studyId = studyId
      userData.siteId = siteId
      userData.subjectId = subjectId
      userData.schemaId = schemaId
      userData.eventId = eventId
      if (timePointUniqueId) {
        userData.timePointUniqueId = timePointUniqueId
      }
      userData.mode = StudyMode
      userData.formId = formId
      userData.queryId = queryId
      userData.status = status
      if (result.isConfirmed) {
        let data = await studySiteDataEntryServices.generateQueryNotificationStatusStudySubjectFormField(userData);
        if (data?.statusCode === 200) {
          setToggle1()
          getStudyFormFieldNotificationHistory()
        }
      }
      setQueryNotificationStatusButtonLoader(false)
    });
  }

  useEffect(() => {
    getTablePropertiesData();
    getStudySiteBasedonAccess()
    getStudyEventRowData()
    getStudyLevelForm()
  }, []);

  useEffect(() => {
    let current = true;
    setSubjectList([]);
    if (siteId) {
      // Ignore a late response for a site that is no longer selected
      getStudySubjectRowData(() => current);
    }
    return () => {
      current = false;
    };
  }, [siteId]);

  useEffect(() => {
    getStudyFormFieldNotificationHistory();
  }, [status, appliedFilters, pageNumber, itemsPerPage]);

  const setDraftFilters = (filters, filterStatus) => {
    setSiteId(filters.siteId);
    setSubjectId(filters.subjectId);
    setEventId(filters.eventId);
    setTimePointId(filters.timePointId);
    setFormId(filters.formId);
    setRepeatEvent(filters.repeatEvent);
    setRepeatForm(filters.repeatForm);
    setDraftStatus(filterStatus);
  };

  const openFilter = () => {
    setDraftFilters(appliedFilters, status);
    setToggle();
  };

  const changeStatus = (value) => {
    setStatus(value);
    setDraftStatus(value);
    setPageNumber(1);
  };

  const applyFilters = () => {
    setAppliedFilters({ siteId, subjectId: siteId ? subjectId : "", eventId, timePointId: eventId ? timePointId : "", formId, repeatEvent, repeatForm });
    setStatus(draftStatus);
    setPageNumber(1);
  };

  const resetFilters = () => {
    setDraftFilters(emptyFilters, "ALL");
    setAppliedFilters({ ...emptyFilters });
    setStatus("ALL");
    setPageNumber(1);
  };

  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update Table Property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.type = "studyLevelDataNotifications";
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(
          userData
        );
        if (data?.statusCode === 200) {
          getStudyFormFieldNotificationHistory();
          getTablePropertiesData();
        }
      }
    });
  };

  const statusList = [
    { label: "All", value: "ALL" },
    { label: "Open", value: "open" },
    { label: "Closed", value: "close" },
    { label: "Re-opened", value: "re-open" },
  ];

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          <InputGroup className="w-auto">
            <button
              onClick={openFilter}
              title="Open Filter"
              className={`updateProfile ${!toggle
                ? "activee"
                : ""
                }`}
            >
              <i style={{ fontSize: 8 }} className="fa-solid fa-filter"></i>
            </button>
            {statusList?.map((item, index) => (
              <button
                key={index}
                onClick={() => changeStatus(item?.value)}
                className={`updateProfile ${status === item?.value
                  ? "activee"
                  : ""
                  }`}
              >
                {item?.label}
              </button>
            ))}
          </InputGroup>
        </div>
        <div className="hstack gap-2">
          {notificationListCount > 0 && (
            <div className="gap-1 hstack">
              <button
                type="button"
                onClick={downloadNotificationReport}
                className="updateProfile"
                disabled={exportLoading}
              >
                <i className="fa-solid fa-download me-1" aria-hidden="true" />
                {exportLoading ? "Preparing Report..." : "Download Report"}
              </button>
              <button
                onClick={() => {
                  setToggle2();
                  getTablePropertiesData();
                }}
                className={`updateProfile`}
              >
                Table Properties
              </button>
            </div>
          )}
        </div>
      </div>
      <SplitPane
        split="horizontal"
        minSize={"100%"}
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
      >
        {loading ? (
          <PageLoader />
        ) : notificationListCount === 0 ? (
          <NoDataFoundTable MSG={"Notification data list not found!"} />
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table w-auto" hover striped bordered>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Sr.
                  </th>
                  {!tableColumns["SITEID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>SiteId</th>
                  )}
                  {!tableColumns["SUBJECTID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>SubjectId</th>
                  )}
                  {!tableColumns["EVENTID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>EventId</th>
                  )}
                  {!tableColumns["TIMEPOINTID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 4)}>TimepointId</th>
                  )}
                  {!tableColumns["REPEATEVENT"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 5)} style={{ width: 85 }}>Repeat Event</th>
                  )}
                  {!tableColumns["FORMNAME"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 6)}>Form Name</th>
                  )}
                  {!tableColumns["FORMVERSION"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 7)}>Form Version</th>
                  )}
                  {!tableColumns["REPEATFORM"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 8)}>Repeat Form</th>
                  )}
                  {!tableColumns["FIELDNAME"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 9)}>Field Name | Label</th>
                  )}
                  {!tableColumns["SUBFIELDNAME"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 10)}>Sub Field Name | Label</th>
                  )}
                  {!tableColumns["FIRSTGENERATEDDT"] && (
                    <th
                      style={{ width: 150 }}
                      onMouseDown={(e) => onMouseDown(e, 11)}
                    >
                      First Generated Date | Time
                    </th>
                  )}
                  {!tableColumns["LASTGENERATEDDT"] && (
                    <th
                      style={{ width: 150 }}
                      onMouseDown={(e) => onMouseDown(e, 12)}
                    >
                      Last Generated Date | Time
                    </th>
                  )}
                  {!tableColumns["NOTIFICATIONAGE"] && (
                    <th
                      style={{ width: 110 }}
                      onMouseDown={(e) => onMouseDown(e, 13)}
                    >
                      Notification Age
                    </th>
                  )}
                  {!tableColumns["NOTIFICATIONSTATUS"] && (
                    <th
                      style={{ width: 50 }}
                      onMouseDown={(e) => onMouseDown(e, 14)}
                    >
                      Status
                    </th>
                  )}
                  <th
                    onMouseDown={(e) => onMouseDown(e, 15)}
                    style={{ width: 80 }}
                    className="text-center"
                  >
                    View Notification
                  </th>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 16)}
                    style={{ width: 80 }}
                    className="text-center"
                  >
                    View Form
                  </th>
                </tr>
              </thead>
              <tbody>
                {notificationList?.map((notification, index) => (
                  <tr key={index} title="View Details">
                    <td className="text-center">{index + 1 + startIndex}.</td>
                    {!tableColumns["SITEID"] && <td>{notification?.siteName}</td>}
                    {!tableColumns["SUBJECTID"] && (
                      <td>{notification?.subjectName}</td>
                    )}
                    {!tableColumns["EVENTID"] && (
                      notification?.dataEntryType === "specialForm" ?
                        <td>
                          Special Form
                        </td>
                        :
                        <td>
                          {notification?.eventName}
                        </td>
                    )}
                    {!tableColumns["TIMEPOINTID"] && (
                      <td>
                        {notification?.timePointId ? notification?.timePointId : "_"}
                      </td>
                    )}
                    {!tableColumns["REPEATEVENT"] && (
                      <td>
                        {notification?.repeatEvent}
                      </td>
                    )}
                    {!tableColumns["FORMNAME"] && (
                      <td>
                        {notification?.formName}
                      </td>
                    )}
                    {!tableColumns["FORMVERSION"] && (
                      <td>
                        v{notification?.formVersion}
                      </td>
                    )}
                    {!tableColumns["REPEATFORM"] && (
                      <td>
                        {notification?.repeatForm}
                      </td>
                    )}
                    {!tableColumns["FIELDNAME"] &&
                      <td>
                        {notification?.mainFieldName === notification?.mainFieldLabel ? (
                          notification?.mainFieldLabel
                        ) : (
                          <>
                            {isHTMLIdentifier(notification?.mainFieldLabel || "") ? (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: notification?.mainFieldLabel,
                                }}
                              />
                            ) : (
                              notification?.mainFieldLabel
                            )} | {notification?.mainFieldName}
                          </>
                        )}
                      </td>
                    }
                    {!tableColumns["SUBFIELDNAME"] &&
                      <td>
                        {notification?.fieldName === notification?.fieldLabel ? (
                          notification?.fieldLabel
                        ) : (
                          <>
                            {isHTMLIdentifier(notification?.fieldLabel || "") ? (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: notification?.fieldLabel,
                                }}
                              />
                            ) : (
                              notification?.fieldLabel
                            )} | {notification?.fieldName}
                          </>
                        )}
                      </td>
                    }
                    {!tableColumns["FIRSTGENERATEDDT"] && (
                      <td>
                        <Moment format="DD MMM YYYY | HH:mm" withTitle>
                          {notification?.createdAt}
                        </Moment>
                      </td>
                    )}
                    {!tableColumns["LASTGENERATEDDT"] && (
                      <td>
                        <Moment format="DD MMM YYYY | HH:mm" withTitle>
                          {notification?.dueAge}
                        </Moment>
                      </td>
                    )}
                    {!tableColumns["NOTIFICATIONAGE"] && (
                      <td className="text-capitalize">{notification?.notificationAge}</td>
                    )}
                    {!tableColumns["NOTIFICATIONSTATUS"] && (
                      <td
                        className={`text-capitalize fw-bold ${(notification?.status === "open" || notification?.status === "re-open")
                          ? "text-danger"
                          : notification?.status === "close"
                            ? "text-success"
                            : "text-muted"
                          }`}
                      >
                        {notification?.status}
                      </td>
                    )}
                    <td className={`text-capitalize text-center`}>
                      <button
                        onClick={() => { setToggle1(); setNotificationData(notification) }}
                        className={`updateProfile`}
                        style={{ padding: "1px 10px" }}
                      >
                        View Notification
                      </button>
                    </td>
                    <td className={`text-capitalize text-center`}>
                      <button
                        onClick={() =>
                          handleAddNewTab(
                            notification?.dataEntryType === "specialForm" ?
                              `Site: ${notification?.siteName} - Subject: ${notification?.subjectName} - Event: Special Event` :
                              notification?.timePointLabel ?
                                `Site: ${notification?.siteName} - Subject: ${notification?.subjectName} - Event: ${notification?.eventName} (${notification?.timePointLabel})` :
                                `Site: ${notification?.siteName} - Subject: ${notification?.subjectName} - Event: ${notification?.eventName}`,
                            "",
                            notification?.dataEntryType === "specialForm" ?
                              `viewEventSchemaFormLists_${notification?.siteId}_${notification?.subjectId}_${notification?.subjectId}SpecialForm`
                              : notification?.timePointUniqueId ?
                                `viewEventSchemaFormLists_${notification?.siteId}_${notification?.subjectId}_${notification?.eventId}_repeatEventId_${notification?.timePointUniqueId}_repeatTimePointId`
                                : `viewEventSchemaFormLists_${notification?.siteId}_${notification?.subjectId}_${notification?.eventId}_repeatEventId`,
                            {
                              siteId: notification?.siteId,
                              siteName: notification?.siteName,
                              subjectId: notification?.subjectId,
                              subjectName: notification?.subjectName,
                              schemaId: notification?.schemaId,
                              formId: notification?.formId,
                              formName: notification?.formName,
                              formVersion: notification?.formVersion,
                              formType: notification?.formType,
                              recordId: notification?.recordId,
                              type: notification?.dataEntryType,
                              autoForm: "yes",
                              viewType: "dataEntry",
                              eventId: notification?.eventId,
                              eventName: notification?.eventName,
                              timePointUniqueId: notification?.timePointUniqueId
                                ? String(notification?.timePointUniqueId)
                                : "",
                              timePointId: notification?.timePointUniqueId
                                ? String(notification?.timePointId)
                                : "",
                              repeatEventId: "",
                              repeatTimePointId: ""
                            }
                          )
                        }
                        className={`updateProfile`}
                        style={{ padding: "1px 10px" }}
                      >
                        View Form
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={notificationListCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </SplitPane>
      <TableProperties
        Show={!toggle2}
        Hide={setToggle2}
        Title={`Table Properties`}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formColumn={formColumn}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        updateTableProperties={updateTableProperties}
      />
      <ManagementFilterCanvas
        Show={!toggle}
        Hide={setToggle}
        Title={`Filter`}
        siteList={siteList}
        subjectList={subjectList}
        eventList={eventList}
        siteId={siteId}
        setSiteId={setSiteId}
        subjectId={subjectId}
        setSubjectId={setSubjectId}
        eventId={eventId}
        setEventId={setEventId}
        timePointId={timePointId}
        setTimePointId={setTimePointId}
        formList={formList}
        formId={formId}
        setFormId={setFormId}
        repeatEvent={repeatEvent}
        setRepeatEvent={setRepeatEvent}
        repeatForm={repeatForm}
        setRepeatForm={setRepeatForm}
        statusOptions={statusList}
        status={draftStatus}
        setStatus={setDraftStatus}
        onApply={applyFilters}
        onReset={resetFilters}
      />

      <FieldErrorNotification
        Show={!toggle1}
        Hide={setToggle1}
        Title={`${notificationData?.mainFieldName} Notification Summary`}
        notificationData={notificationData}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        dataEntryQueryNotificationDiscussionLoader={dataEntryQueryNotificationDiscussionLoader}
        queryNotificationStatusButtonLoader={queryNotificationStatusButtonLoader}
        dataEntryQueryNotificationDiscussion={dataEntryQueryNotificationDiscussion}
        getStudySubjectFormFieldQueryNotificationDiscussionDataEntry={getStudySubjectFormFieldQueryNotificationDiscussionDataEntry}
        generateQueryNotificationStatusStudySubjectFormField={generateQueryNotificationStatusStudySubjectFormField}
      />
    </>
  );
};

export default ManageNotificationDataList;
